import { RootState } from '@/core/store/store'
import { createSelector } from '@reduxjs/toolkit'

const orders = (state: RootState) => state.ordersReducer
export const ordersSelector = createSelector(
  orders,
  ordersReducer => ordersReducer.orders,
)

const order = (state: RootState) => state.ordersReducer
export const orderSelector = createSelector(
  order,
  ordersReducer => ordersReducer.order,
)
